import { z } from 'zod';
import type { TranslateFn } from '@/core/i18n/use-intl';
import { jsonSchemaType } from '@/shared/schema';

export const createObjectSchema = (
  t: TranslateFn,
  categoryMetadataSchema: z.ZodObject<z.ZodRawShape>,
  dynamicMetadataSchema: z.ZodObject<z.ZodRawShape>
) =>
  z.object({
    name: z.string().min(1, t('validation.required')),
    description: z.string().optional(),
    category: z.string().optional().nullable(),
    assignedCustomer: z.string().optional(),
    assignedHelicopterServiceProvider: z.string().optional().nullable(),
    linkedOffshoreObjects: z.array(z.string()).optional(),
    linkedWindpark: z.string().optional().nullable(),
    dynamicMetadataSchema: jsonSchemaType,
    categoryMetadataValues: categoryMetadataSchema,
    dynamicMetadataValues: dynamicMetadataSchema,
  });

// Default schema for cases where we don't need validation
const _fakeT: TranslateFn = () => 'Required';
export const objectFormSchema = createObjectSchema(
  _fakeT,
  z.object({}).catchall(z.unknown()),
  z.object({}).catchall(z.unknown())
);
